import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const ProblemReportsSlice = createSlice({
    name: 'problemReports',
    initialState,
    reducers: {
        getProblemReportsRequest(state) {
            state.loading = true;
            state.error = undefined;
        },
        getProblemReportsSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProblemReportsError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getProblemReportsRequest,
    getProblemReportsSuccess,
    getProblemReportsError,
} = ProblemReportsSlice.actions;

export default ProblemReportsSlice.reducer;

